import React, { useState, useEffect } from 'react';
import {
  getMoveTransactionById,
  clearMoveTransaction,
} from '../../actions/keyCodeActions';
import MovedTransactionDetails from './components/MovedTransactionDetails';
import ActionBar from '../layout/ActionBar';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks';
import {
  addToGroup,
  removeFromGroup,
} from '../../middleware/signalRMiddleware';

function MovedTransaction() {
  const { id } = useParams<{ id: string }>();
  const currentUser = useAppSelector((state) => state.auth);
  const moveTransaction = useAppSelector((state) =>
    (state.moveTransactions as { id?: string }[] | undefined)?.find((t) => t.id === id)
  );
  const dispatch = useAppDispatch();
  const [, setPageTitle] = usePageTitle(['Moved transaction', 'Keys']);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [transaction, setTransaction] = useState<any>();

  useEffect(() => {
    if (id) {
      getMoveTransactionById(id)
        .then((d) => {
          setTransaction(d);
          setPageTitle([d.keyProviderName ?? 'Moved transaction', 'Moved transaction', 'Keys']);
        })
        .catch(() => {
          navigate('/keys/moved/');
          toast.error(t('Transaction not found'));
        });
    }
  }, [id, t, setPageTitle, navigate]);

  useEffect(() => {
    if (
      transaction &&
      (transaction.status === 'Pending' ||
        transaction.status === 'Pending Authorisation')
    ) {
      const key = `move:${transaction.id}`;
      dispatch(addToGroup(key));
      return () => {
        dispatch(removeFromGroup(key));
      };
    }
  }, [transaction, dispatch]);

  useEffect(() => {
    if (moveTransaction && moveTransaction.id === id) {
      setTransaction((prevState: any) => ({
        ...prevState,
        ...moveTransaction,
      }));
      return () => {
        dispatch(clearMoveTransaction());
      };
    }
  }, [moveTransaction, id, dispatch]);

  return (
    <>
      <ActionBar
        breadcrumb={[
          { link: '/keys/moved', label: t('Moved transactions') },
          { label: t('Move transaction') },
        ]}
      />
      {transaction && (
        <MovedTransactionDetails
          transaction={transaction}
          currentUser={currentUser}
        />
      )}
    </>
  );
}

export default MovedTransaction;
